import * as styles from './Dashboard.css';

export const DashboardSectionWrapper = ({
  fixed = false,
  hasPadding = true,
  children,
}: {
  fixed?: boolean;
  hasPadding?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={
        hasPadding
          ? fixed
            ? styles.sectionWrapperFixed
            : styles.sectionWrapper
          : undefined
      }
    >
      {children}
    </div>
  );
};
